<template>
  <div
    v-if="currentProgress >= 0"
    :class="['progress-bar', { 'progress-bar-white': !isDark }]"
  >
    <nuxt-icon name="checked" />
    <nuxt-icon name="checked" :class="{ 'icon-checked': currentProgress >= 33.3 }" :filled="currentProgress >= 33.3" />
    <nuxt-icon name="checked" :class="{ 'icon-checked': currentProgress >= 67.7 }" :filled="currentProgress >= 67.7" />
    <nuxt-icon name="checked" :class="{ 'icon-checked': currentProgress === 100 }" :filled="currentProgress === 100" />

    <div class="progress-bar__line">
      <div
        :class="['progress-bar__fill-line', { 'progress-bar__fill-line-empty': currentProgress === 0 }]"
        :style="{ width: `${currentProgress}%` }"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useQuiz } from '@/composables/quiz';

defineProps({
  isDark: { type: Boolean, default: false },
});
const { currentProgress } = useQuiz();
</script>

<style lang="scss" scoped>
.progress-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 10;
  max-width: 311px;
  margin: 0 auto;
  margin-bottom: 32px;
  margin-top: 8px;

  .nuxt-icon {
    line-height: 0;
    color: $white;
    z-index: 12;
    font-size: 18px;

    &:first-child {
      color: $pink;
    }
  }

  &__line {
    position: absolute;
    width: 100%;
    height: 6px;
    left: 0;
    right: 0;
    background: $white;
    z-index: 11;
  }

  &__fill-line {
    position: absolute;
    left: 0;
    background: $pink;
    height: 100%;
    padding: 0 12px;
    border-radius: 43px;
  }

  &__fill-line-empty {
    padding: 0;
  }
}

.progress-bar-white {
  .nuxt-icon {
    color: $gray-bg;

    &:first-child {
      color: $pink;
    }
  }

  .progress-bar__line {
    background: $gray-bg;
  }

  .progress-bar__fill-line {
    background: $pink;
  }
}
</style>

<style lang="scss">
.icon-checked {
  path {
    fill: $pink;
  }

  circle {
    fill: $white;
  }
}

.progress-bar-white {
  .icon-checked {
    path {
      fill: $pink;
    }

    circle {
      fill: $white;
    }
  }
}
</style>
